module.exports = __webpack_public_path__ + "static/media/how-it-works-a-few-steps-01-2x.9e51539d.jpg";